import type { DropdownItemBase } from '@/components/Autocomplete/autocomplete.types';

import type { GetAllPicklistsQuery } from '../_graphql/query/GetAllPicklists.hook';

type CountrySource = GetAllPicklistsQuery['countries'];

export const extractCountriesAndStates = (data?: CountrySource | null) => {
	const countryOptions: DropdownItemBase[] = [];
	const stateOptionsDictionary: Record<string, DropdownItemBase[]> = {};

	if (!data) {
		return { countryOptions, stateOptionsDictionary };
	}

	data.forEach(country => {
		if (!country || !country.id || !country.name) return;

		countryOptions.push({
			id: country.id,
			name: country.name
		});

		if (country.states) {
			stateOptionsDictionary[country.id] = country.states
				.filter(
					(state): state is { id: string; name: string } =>
						!!state && !!state.id && !!state.name
				)
				.map(state => ({
					id: state.id,
					name: state.name
				}));
		} else {
			stateOptionsDictionary[country.id] = [];
		}
	});

	return { countryOptions, stateOptionsDictionary };
};
